import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "5f30a684-706f-48af-b1d7-b7ea641fb73a",
    content: "The sound pressure is halved.",
    options: {},
  },
  {
    id: "3ab372b3-55c8-4aa6-940b-397a36d29135",
    content: "The sound pressure changes by a factor of 1/√2.",
    options: {},
  },
  {
    id: "a32e9a45-1e44-446b-ba6c-c07b02a27e6d",
    content: "The sound pressure change depends on the resolution of the HRTF grid.",
    options: {},
  },
  {
    id: "3af7bdd4-2682-49f1-bb6e-60dc1dea755d",
    content: "The sound pressure doubles.",
    options: {},
  },
];

export const task: Task = {
  id: "921e109b-7198-4e71-8a61-e562f4f2664d",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["5f30a684-706f-48af-b1d7-b7ea641fb73a"],
};
